const photocodeScannedIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="24px" height="20px" viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>qr-code-scan</title>
    <desc>Created with Sketch.</desc>
    <g id="Photocode" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-photocode---list" transform="translate(-656.000000, -249.000000)">
            <g id="Visitors-Copy-5" transform="translate(620.000000, 211.000000)">
                <g id="qr-code-scan" transform="translate(36.000000, 36.000000)">
                    <g id="Outline_Icons_1_" transform="translate(0.000000, 2.000000)" stroke="#00A3D9" stroke-linecap="round" stroke-linejoin="round">
                        <g id="Outline_Icons">
                            <g id="Group">
                                <polyline id="Path" points="0.5 16.531 0.5 19.5 3.469 19.5"></polyline>
                                <polyline id="Path" points="3.469 0.5 0.5 0.5 0.5 3.469"></polyline>
                                <polyline id="Path" points="23.5 3.469 23.5 0.5 20.531 0.5"></polyline>
                                <polyline id="Path" points="20.531 19.5 23.5 19.5 23.5 16.531"></polyline>
                                <rect id="Rectangle" x="5.5" y="4.5" width="2" height="2"></rect>
                                <rect id="Rectangle" x="5.5" y="13.5" width="2" height="2"></rect>
                                <rect id="Rectangle" x="16.5" y="4.5" width="2" height="2"></rect>
                                <polyline id="Path" points="5.5 8.5 8.5 8.5 8.5 9.5"></polyline>
                                <path d="M5.5,11.5 L9.5,11.5" id="Path"></path>
                                <polyline id="Path" points="16.516 13.5 18.5 13.5 18.5 15.5 14.516 15.5 14.516 10.5 18.5 10.5 18.5 11.5"></polyline>
                                <path d="M11.516,11.5 L11.516,10.5" id="Path"></path>
                                <path d="M14.516,5.5 L14.516,4.5" id="Path"></path>
                                <path d="M12.5,13.5 L11.516,13.5" id="Path"></path>
                                <polyline id="Path" points="9.5 13.531 9.5 15.5 12.5 15.5"></polyline>
                                <polyline id="Path" points="9.5 4.516 9.5 6.5 10.5 6.5"></polyline>
                                <polyline id="Path" points="12.5 4.516 12.5 8.5 10.5 8.5"></polyline>
                                <path d="M14.516,8.5 L18.516,8.5" id="Path"></path>
                            </g>
                        </g>
                    </g>
                    <g id="Invisible_Shape">
                        <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`;

export default photocodeScannedIcon;
